<script setup lang="ts">
import { useBannerInfo } from '~/api/service/general.service'
import EpBadge from '~/components/badge/EpBadge.vue'
import EpIcon from '~/components/icon/EpIcon.vue'
import { routes } from '~/routes'
import { contentType, eventType } from '~/types/content.type'

const { data } = useBannerInfo()
const containerRef = ref(null)

const router = useRouter()

const goContentListPage = (category: string) => {
  if (category.toUpperCase() in eventType) {
    router.push(routes.getContentPage(contentType.EVENT))
    return
  }
  router.push(routes.getContentPage(category))
}
</script>

<template>
  <div class="banner-container">
    <Swiper
      :modules="[SwiperAutoplay]"
      ref="containerRef"
      :slides-per-view="1"
      loop
      direction="vertical"
      :autoplay="{
        delay: 3000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true
      }"
      class="!ml-0 h-9 !truncate"
    >
      <SwiperSlide
        v-for="banner in data"
        :key="banner.contentId"
        class="banner-item"
      >
        <EpBadge
          :padding-x="8"
          :label="banner.category"
          :padding-y="0"
          :bg-opacity="20"
          :text-size="12"
          bold
          class="shrink-0 cursor-pointer"
          :value="banner.category"
          @click="goContentListPage"
        />
        <NuxtLink
          class="title"
          :to="routes.getContentDetailPage(banner.contentId, banner.eventType || banner.category)"
        >
          {{ banner.title }}
        </NuxtLink>
      </SwiperSlide>
    </Swiper>
    <NuxtLink
      class="link"
      :to="routes.getContentPage()"
    >
      Content
      <EpIcon name="east" />
    </NuxtLink>
  </div>
</template>

<style scoped lang="scss">
.banner-container {
  @apply flex max-h-9 items-center gap-x-2 bg-white/10 p-2 truncate justify-between w-full overflow-hidden;

  .banner-item {
    @apply flex truncate items-center gap-x-4 leading-6;

    .title {
      @apply truncate;

      &:hover {
        @apply underline;
      }
    }
  }

  .link {
    @apply font-bold flex items-center gap-x-2 shrink-0;
  }
}
</style>